export default __webpack_public_path__ + "static/media/gallery-wip-neck_04.1317a075.jpg";